import RoleLevelReportPage from "./role-level-report-page.jsx";

export default RoleLevelReportPage;
